import { useCallback, useState } from "react";
import { toast } from "sonner";
import { api, apiError, openRazorpayCheckout } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useStore } from "@/context/StoreContext";

/**
 * Shared PRIME purchase flow: create pending purchase → Razorpay checkout →
 * server-side verify → membership active. Razorpay online only (never COD/credit).
 */
export function usePrimePurchase() {
  const { user } = useAuth();
  const { refreshPrime } = useStore();
  const [buying, setBuying] = useState(false);

  const buy = useCallback(async () => {
    if (!user || buying) return false;
    setBuying(true);
    try {
      const { data } = await api.post("/prime/buy");
      const resp = await openRazorpayCheckout({
        keyId: data.razorpay.key_id,
        orderId: data.razorpay.order_id,
        amountPaise: data.razorpay.amount_paise,
        description: "PAQVERO PRIME membership",
        prefill: { name: user.name, email: user.email, contact: user.mobile || "" },
      });
      const { data: ver } = await api.post("/prime/verify", {
        razorpay_order_id: resp.razorpay_order_id,
        razorpay_payment_id: resp.razorpay_payment_id,
        razorpay_signature: resp.razorpay_signature,
      });
      if (ver.ok) {
        toast.success("Welcome to PAQVERO PRIME — your benefits are live!");
        await refreshPrime();
        return true;
      }
      return false;
    } catch (err) {
      if (err?.reason !== "cancelled") toast.error(apiError(err, "Could not complete the PRIME purchase"));
      return false;
    } finally {
      setBuying(false);
    }
  }, [user, buying, refreshPrime]);

  return { buy, buying };
}
